module.exports = __webpack_public_path__ + "static/media/90.802f81a0.png";